<template>
  <Slidebar @closeMe="closeSlidebar" :large="true">
    <h4>Magnstofna kennslustund</h4>
    <b-form>
      <!--@submit.prevent="validateBeforeSubmit" novalidate-->
      <table class="table less-padding no-border">
        <tr>
          <th>Kennslutímabil</th>
          <td colspan="4">{{ item.term.undirsk_heiti }} - {{ item.term.onn_heiti }}</td>
        </tr>
        <tr>
          <th>Áfangi*</th>
          <td colspan="4">
            <b-form-group
              label-for="modules"
              :state="submitted && errors.has('modules') ? false : ''"
              :invalid-feedback="errors.first('modules')"
            >
              <v-select
                id="modules"
                name="modules"
                v-model="form.module"
                :clearable="false"
                v-validate="'required'"
                :state="submitted && errors.has('modules') ? false : ''"
                :options="modules"
                label="namsgrein_afanganr"
                @input="
                  loadGroups();
                  validated = false;
                "
                data-vv-as="áfangi"
              >
              </v-select>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <th>Hópur*</th>
          <td colspan="4">
            <b-form-group
              label-for="groups"
              :state="submitted && errors.has('groups') ? false : ''"
              :invalid-feedback="errors.first('groups')"
            >
              <v-select
                id="groups"
                name="groups"
                v-model="form.group"
                :clearable="false"
                v-validate="'required'"
                :state="submitted && errors.has('groups') ? false : ''"
                :options="groups"
                label="hopur"
                data-vv-as="hópur"
                @input="
                  loadCurrentTeachers();
                  validated = false;
                "
              >
              </v-select>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <th>Kennari/ar*</th>
          <td colspan="4">
            <b-form-group
              label-for="teachers"
              :state="submitted && errors.has('teachers') ? false : ''"
              :invalid-feedback="errors.first('teachers')"
            >
              <v-select
                id="teachers"
                name="teachers"
                v-model="form.teachers"
                multiple
                v-validate="'required'"
                :state="submitted && errors.has('teachers') ? false : ''"
                :options="teachers"
                data-vv-as="kennari"
                @input="validated = false"
              >
              </v-select>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <th>Stofa</th>
          <td colspan="4">
            <b-form-group
              label-for="classrooms"
              :state="submitted && errors.has('classrooms') ? false : ''"
              :invalid-feedback="errors.first('classrooms')"
            >
              <v-select
                id="classrooms"
                name="classrooms"
                v-model="form.classrooms"
                multiple
                :state="submitted && errors.has('classrooms') ? false : ''"
                :options="classrooms"
                @input="validated = false"
              >
              </v-select>
            </b-form-group>
          </td>
        </tr>

        <tr>
          <th>Búnaður</th>
          <td>
            <b-form-checkbox v-model="form.orderEquipment" class="d-inline-block"></b-form-checkbox> Panta búnað
            <b-form-group
              class="mt-2"
              label-for="bunadur"
              :state="submitted && errors.has('bunadur') ? false : ''"
              :invalid-feedback="errors.first('bunadur')"
              v-if="form.orderEquipment"
            >
              <v-select
                id="bunadur"
                name="bunadur"
                v-model="form.equipment"
                :options="equipments"
                label="heiti"
                :state="submitted && errors.has('bunadur') ? false : ''"
                v-validate="form.orderEquipment ? 'required' : ''"
                data-vv-as="búnaður"
                @input="validated = false"
              >
              </v-select>
            </b-form-group>
          </td>
        </tr>
        <tr v-if="!validated && this.form.dates.length === 0">
          <th>Tímabil</th>
          <td colspan="4">
            <div class="d-inline-block">
              <div v-for="(period, idx) in form.periods" :key="idx">
                <div class="d-inline-block">
                  <b-form-group
                    label="Frá"
                    :label-for="`dateFrom${idx}`"
                    :state="submitted && errors.has(`dateFrom${idx}`) ? false : ''"
                    :invalid-feedback="errors.first(`dateFrom${idx}`)"
                  >
                    <datepicker
                      :id="`dateFrom${idx}`"
                      :name="`dateFrom${idx}`"
                      v-model="period.dateFrom"
                      :language="lang"
                      :monday-first="true"
                      format="dd.MM.yyyy"
                      :typeable="false"
                      :ref="`dateFromOpenPickr${idx}`"
                      data-vv-as="dags frá"
                      v-validate="'required'"
                      :state="submitted && errors.has(`dateFrom${idx}`) ? false : ''"
                    ></datepicker>
                  </b-form-group>
                </div>
                <div class="d-inline-block pl-4">
                  <b-form-group
                    label="Til"
                    :label-for="`dateTo${idx}`"
                    :state="submitted && errors.has(`dateTo${idx}`) ? false : ''"
                    :invalid-feedback="errors.first(`dateTo${idx}`)"
                  >
                    <datepicker
                      :id="`dateTo${idx}`"
                      :name="`dateTo${idx}`"
                      v-model="period.dateTo"
                      :language="lang"
                      :monday-first="true"
                      format="dd.MM.yyyy"
                      :typeable="false"
                      :ref="`dateTopenPickr${idx}`"
                      data-vv-as="dags til"
                      v-validate="'required'"
                      :state="submitted && errors.has(`dateTo${idx}`) ? false : ''"
                    ></datepicker>
                  </b-form-group>
                </div>
                <div class="d-inline-block pl-4">
                  <b-btn variant="primary" size="sm" @click="removeMultiPeriod(idx)" style="vertical-align: bottom">
                    <i class="fa fa-trash" />
                  </b-btn>
                </div>
              </div>
            </div>
            <div class="d-inline-block pl-3 float-right" style="vertical-align: top; margin-top: 30px">
              <b-btn variant="primary" class="mr-2" size="sm" @click="copyTermDates()">Nota dags. tímabils</b-btn>
              <b-btn variant="primary" size="sm" @click="addMultiPeriod()">Bæta við tímabili</b-btn>
            </div>
          </td>
        </tr>
        <tr v-if="!validated && this.form.dates.length === 0">
          <td />
          <td colspan="4">
            <div class="d-inline-block align-bottom">
              <div>
                <i>Lengd kennslustunda: </i>
                <b-form-input type="number" class="d-inline-block" style="padding: 2px; width: 60px; height: 30px" v-model="classLength" />
              </div>
            </div>
            <div class="d-inline-block align-bottom pl-4">
              <div>
                <i class="pl-2">Sleppa frídögum: </i>
                <b-form-checkbox class="d-inline-block" v-model="form.holidays" />
              </div>
            </div>
          </td>
        </tr>
        <TableRowLoader v-if="validating" colspan="5" :center="true" />
        <tr v-if="validated && this.form.dates.length > 0">
          <td colspan="5">
            <div class="alert alert-info">
              <i class="fa fa-info-circle"></i>
              Búið er að athuga árekstra. Vinsamlegast hakaðu við þær dagsetningar sem á að stofna og smelltu á <strong>Stofna</strong>
              <div>
                <b-link @click="clearValidation" style="color: inherit"><i>Smelltu hér til að fara aftur í tímabil</i></b-link>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="validated && this.form.dates.length === 0">
          <td colspan="5">
            <div class="alert alert-warning">
              <i class="fa fa-info-circle"></i>
              Valdar dagsetningar stemma ekki við dagana sem þú hefur valið.
              <div>
                <b-link @click="clearValidation" style="color: inherit"><i>Smelltu hér til að fara aftur í tímabil</i></b-link>
              </div>
            </div>
          </td>
        </tr>
        <tr v-for="day in form.weekdays.filter(x => x.id <= this.daysInWeek && this.form.dates.length === 0 && !validating)" :key="day.id">
          <td>{{ day.name }}</td>
          <td colspan="4">
            <div class="d-inline-block" style="font-size: 12px">
              <b-btn variant="primary" size="sm" @click="addMultiDate(day)"> Bæta við </b-btn>
            </div>
            <div class="d-inline-block float-right">
              <b-dropdown :id="`dropdown-${day.id}`" text="Afrita frá öðrum degi" size="sm" variant="dark">
                <b-dropdown-item v-for="d in getDays(day)" :key="d.id" @click="copyFromOtherDay(day, d.id)">{{ d.name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <table class="table less-padding no-border">
              <tr v-if="day.times.length > 0">
                <th>Tími frá</th>
                <th>Tími til</th>
                <th />
              </tr>
              <tr v-for="(date, index) in day.times" :key="index">
                <td>
                  <b-form-group
                    :label-for="`timeFrom${day.id}${index}`"
                    :state="submitted && errors.has(`timeFrom${day.id}${index}`) ? false : ''"
                    :invalid-feedback="errors.first(`timeFrom${day.id}${index}`)"
                  >
                    <masked-input
                      :id="`timeFrom${day.id}${index}`"
                      :name="`timeFrom${day.id}${index}`"
                      v-model="date.time_from"
                      mask="11:11"
                      placeholder="hh:mm"
                      style="padding: 2px 2px 2px 2px; width: 60px; height: 30px; border: 1px solid #ced4da"
                      v-validate="{ required: true, regex: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ }"
                      data-vv-as="tími frá"
                      :state="submitted && errors.has(`timeFrom${day.id}${index}`) ? false : ''"
                      @input="updateTimeTo(day, index)"
                    />
                  </b-form-group>
                </td>
                <td>
                  <b-form-group
                    :label-for="`timeTo${day.id}${index}`"
                    :state="submitted && errors.has(`timeTo${day.id}${index}`) ? false : ''"
                    :invalid-feedback="errors.first(`timeTo${day.id}${index}`)"
                  >
                    <masked-input
                      :id="`timeTo${day.id}${index}`"
                      :name="`timeTo${day.id}${index}`"
                      :ref="`timeTo${day.id}${index}`"
                      v-model="date.time_to"
                      mask="11:11"
                      placeholder="hh:mm"
                      style="padding: 2px 2px 2px 2px; width: 60px; height: 30px; border: 1px solid #ced4da"
                      v-validate="{ required: true, regex: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ }"
                      data-vv-as="tími til"
                      :state="submitted && errors.has(`timeTo${day.id}${index}`) ? false : ''"
                    />
                  </b-form-group>
                </td>
                <td>
                  <b-btn variant="primary" size="sm" @click="removeMultiDate(day, index)"><i class="fa fa-trash" /></b-btn>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr v-if="this.form.dates.length > 0">
          <th>Stofna <b-form-checkbox class="d-inline-block ml-2" v-model="selectAll" @input="updateSelectAll()" /></th>
          <th>Dags.</th>
          <th>Tími frá</th>
          <th>Tími til</th>
          <th>
            <i class="pl-2">Sleppa frídögum: </i>
            <b-form-checkbox class="d-inline-block" v-model="form.holidays" />
          </th>
        </tr>
        <tbody v-for="(date, index) in getDates" :key="index" style="border: 0">
          <tr>
            <td v-if="validated" style="vertical-align: top">
              <b-form-checkbox v-model="date.copy" />
            </td>
            <td>
              <b-form-group
                :label-for="`date${index}`"
                :state="submitted && errors.has(`date${index}`) ? false : ''"
                :invalid-feedback="errors.first(`date${index}`)"
              >
                <datepicker
                  :id="`date${index}`"
                  :name="`date${index}`"
                  v-model="date.date"
                  :language="lang"
                  :monday-first="true"
                  format="dd.MM.yyyy"
                  :typeable="false"
                  v-validate="'required'"
                  data-vv-as="dags"
                  @change="validated = false"
                  :state="submitted && errors.has(`date${index}`) ? false : ''"
                  :ref="`dateOpenPickr${index}`"
                ></datepicker>
              </b-form-group>
            </td>
            <td>
              <b-form-group
                :label-for="`timeFrom${index}`"
                :state="submitted && errors.has(`timeFrom${index}`) ? false : ''"
                :invalid-feedback="errors.first(`timeFrom${index}`)"
              >
                <masked-input
                  :id="`timeFrom${index}`"
                  :name="`timeFrom${index}`"
                  v-model="date.time_from"
                  mask="11:11"
                  placeholder="hh:mm"
                  style="padding: 2px 2px 2px 2px; width: 60px; height: 30px; border: 1px solid #ced4da"
                  v-validate="{ required: true, regex: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ }"
                  data-vv-as="tími frá"
                  :state="submitted && errors.has(`timeFrom${index}`) ? false : ''"
                  @input="updateTimeTo(null, index)"
                />
              </b-form-group>
            </td>
            <td>
              <b-form-group
                :label-for="`timeTo${index}`"
                :state="submitted && errors.has(`timeTo${index}`) ? false : ''"
                :invalid-feedback="errors.first(`timeTo${index}`)"
              >
                <masked-input
                  :id="`timeTo${index}`"
                  :name="`timeTo${index}`"
                  :ref="`timeTo${index}`"
                  v-model="date.time_to"
                  mask="11:11"
                  placeholder="hh:mm"
                  style="padding: 2px 2px 2px 2px; width: 60px; height: 30px; border: 1px solid #ced4da"
                  v-validate="{ required: true, regex: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ }"
                  data-vv-as="tími til"
                  :state="submitted && errors.has(`timeTo${index}`) ? false : ''"
                />
              </b-form-group>
            </td>
            <td>
              <b-btn variant="primary" size="sm" @click="removeDate(index)"><i class="fa fa-trash" /></b-btn>
            </td>
          </tr>
          <tr v-if="validated && date.equipment === 1" style="font-size: 13px">
            <td colspan="5">
              <div class="text-danger">Búnaður er bókaður á valdri dagsetningu. Hann verður ekki pantaður.</div>
            </td>
          </tr>
          <tr v-if="validated && !date.validation.can_book">
            <td colspan="5">
              <div class="alert alert-danger mb-0" style="font-size: 13px; padding: 10px">
                <div v-if="!date.validation.hopur.availability.available">Hópaárekstur: Hópurinn er nú þegar bókaður á þessum tíma.</div>
                <div v-if="!date.validation.hopur.onn.date_in_range">
                  Dagsetning er ekki innan gildistísma hóps. Vinsamlegast veldu á milli
                  <strong> {{ date.validation.hopur.onn.from }} </strong> og <strong>{{ date.validation.hopur.onn.to }}</strong>
                </div>
                <div v-if="date.validation.stofa && date.validation.stofa.filter(x => !x.classroom_size_ok).length > 0">
                  <div v-for="(stofa, idx) in date.validation.stofa.filter(x => !x.classroom_size_ok)" :key="idx">
                    <div>Eftirfarandi stofa er of lítil: {{ stofa.short_name }}</div>
                    <div>
                      Fjöldi í hóp er: <strong> {{ date.validation.hopur.number_of_students }}</strong
                      >.
                    </div>
                    <div>
                      Hámarksfjöldi í stofu er: <strong> {{ stofa.max_students }}</strong
                      >.
                    </div>
                  </div>
                </div>
                <div v-if="!date.validation.bookings.available">
                  Stofupantanir:
                  <span v-for="(clash, idx) in date.validation.bookings.clashes" :key="idx">
                    <span v-if="idx != 0">, </span><strong>{{ clash.starfsm_nafn }} - {{ clash.skyring }}</strong> {{ clash.timi_fra }}-{{
                      clash.timi_til
                    }}</span
                  >
                </div>
                <div v-if="!date.validation.availability.available">
                  Stofuárekstur:
                  <span v-for="(clash, idx) in date.validation.availability.clashes" :key="idx">
                    <span v-if="idx != 0">, </span><strong>{{ clash.afanga_nr }}({{ clash.hopur }})</strong> {{ clash.timi_fra }}-{{
                      clash.timi_til
                    }}
                  </span>
                </div>
                <div v-for="(t, idx) in date.validation.teachers.filter(x => !x.available)" :key="idx">
                  Kennaraárekstur: <strong>{{ t.nafn }} {{ t.skammst }}</strong
                  >.
                  <span v-for="(clash, idx2) in t.clashes" :key="idx2"
                    ><span v-if="idx2 != 0">, </span> {{ clash.heiti }} {{ clash.timi_fra }}-{{ clash.timi_til }}</span
                  >
                </div>
                <div v-for="(t, idx) in date.validation.teachers.filter(x => x.locked)" :key="idx">
                  Kennaralæsing: <strong>{{ t.nafn }} {{ t.skammst }}</strong
                  >.
                  <span v-for="(locks, idx2) in t.locks" :key="idx2"
                    ><span v-if="idx2 != 0">, </span> <strong>{{ locks.lysing }}</strong> {{ locks.timi_fra }}-{{ locks.timi_til }}</span
                  >
                </div>
                <div v-if="date.validation.locks.classroom_locked">
                  Stofulæsing:
                  <span v-for="(clash, idx) in date.validation.locks.classroom" :key="idx"
                    ><span v-if="idx != 0">, </span> <strong>{{ clash.lysing }}</strong> {{ clash.timi_fra }}-{{ clash.timi_til }}</span
                  >
                </div>
                <div v-if="date.validation.locks.semester_locked">
                  Stofulæsing:
                  <span v-for="(clash, idx) in date.validation.locks.semester" :key="idx"
                    ><span v-if="idx != 0">, </span> <strong>{{ clash.lysing }}</strong> {{ clash.timi_fra }}-{{ clash.timi_til }}</span
                  >
                </div>
                <div v-if="date.validation.holidays.length > 0">
                  Frídagar:
                  <span v-for="(clash, idx) in date.validation.holidays" :key="idx"
                    ><span v-if="idx != 0">, </span> <strong>{{ clash.heiti }}</strong> {{ clash.timi_fra
                    }}<span v-if="clash.timi_til">-{{ clash.timi_til }}</span></span
                  >
                </div>

                <div v-if="date.validation.student_clashes.length > 0">
                  Nemendaárekstur:
                  <span v-for="(clash, idx) in date.validation.student_clashes" :key="idx">
                    <span v-if="idx != 0">, </span><strong>{{ clash.nafn }}</strong> {{ clash.heiti }}
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <b-btn variant="secondary" @click="validateBeforeSubmit()">
        {{ this.validated ? 'Stofna' : 'Athuga árekstur' }}
      </b-btn>
    </b-form>
  </Slidebar>
</template>

<script>
import school from '@/api/school';
import terms from '@/api/terms';
import staff from '@/api/staff';
import common from '@/api/common';
import requests from '@/api/requests';
import structure from '@/api/structure';
import { mapActions } from 'vuex';
import moment from 'moment';

import Slidebar from '@/components/common/Slidebar.vue';
import Datepicker from 'vuejs-datepicker';
import { is } from 'vuejs-datepicker/dist/locale';
import TableRowLoader from '@/components/common/TableRowLoader.vue';
import MaskedInput from 'vue-masked-input';

export default {
  name: 'mass-create-timetable-slide-bar',
  props: ['item'], // 'editing', 'creating'],
  components: {
    Slidebar,
    Datepicker,
    TableRowLoader,
    MaskedInput,
  },
  computed: {
    getDates() {
      return this.form.dates.filter(
        x => !this.form.holidays || (this.form.holidays && x.validation && x.validation.holidays && x.validation.holidays.length === 0),
      );
    },
  },
  data() {
    return {
      regexTime: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
      lang: is,
      classLength: 60,
      daysInWeek: 5,
      submitted: false,
      validated: false,
      validating: false,
      saving: false,
      loading: {
        modules: false,
        groups: false,
        teachers: false,
        classrooms: false,
        equipments: false,
      },
      modules: [],
      groups: [],
      teachers: [],
      classrooms: [],
      form: {
        module: '',
        group: '',
        teachers: [],
        classrooms: [],
        dateFrom: '',
        dateTo: '',
        periods: [{ dateFrom: '', dateTo: '' }],
        holidays: true,
        dates: [],
        weekdays: [
          { id: 1, name: 'Mánudagur', times: [], copyFrom: '' },
          { id: 2, name: 'Þriðjudagur', times: [], copyFrom: '' },
          { id: 3, name: 'Miðvikudagur', times: [], copyFrom: '' },
          { id: 4, name: 'Fimmtudagur', times: [], copyFrom: '' },
          { id: 5, name: 'Föstudagur', times: [], copyFrom: '' },
          { id: 6, name: 'Laugardagur', times: [], copyFrom: '' },
          { id: 7, name: 'Sunnudagur', times: [], copyFrom: '' },
        ],
        orderEquipment: false,
        equpment: '',
      },
      selectAll: false,
    };
  },
  methods: {
    closeSlidebar() {
      this.$emit('closeSlidebar');
    },
    async loadEquipments() {
      try {
        this.loading.equipments = true;
        this.equipments = [];
        const response = await structure.getEquipmentList();
        this.equipments = response.data.items;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading.equipments = false;
      }
    },
    async loadGroups() {
      this.groups = [];
      this.form.group = '';
      this.form.teachers = [];
      this.validated = false;
      if (this.form.module) {
        this.loading.groups = true;
        try {
          const response = await school.getTermModulesGroups(this.form.module.annir_afangar_id);
          this.groups = response.data.items;
          this.form.group = '';
          if (this.item.group) {
            this.form.group = this.groups.find(x => x.hopur_id === this.item.group.hopur_id);
            this.loadCurrentTeachers();
          }
        } catch (e) {
          this.$log.error(e);
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        } finally {
          this.loading.modules = false;
        }
      }
    },
    async loadModules() {
      if (this.item && this.item.term) {
        this.loading.modules = true;
        try {
          const response = await terms.getTermModules(this.item.term.onn_id);
          this.modules = response.data.items;
          this.form.module = '';
          if (this.item.module) {
            this.form.module = this.modules.find(x => x.annir_afangar_id === this.item.module.annir_afangar_id);
            this.loadGroups();
          }
        } catch (e) {
          this.$log.error(e);
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        } finally {
          this.loading.modules = false;
        }
      }
    },
    async loadTeachers() {
      this.loading.teachers = true;
      try {
        const response = await staff.getStaffList();
        this.teachers = response.data.items.map(x => ({
          ...x,
          label: `${x.nafn} - ${x.skammst}`,
        }));
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading.teachers = false;
      }
    },
    async loadClassrooms() {
      this.loading.classrooms = true;
      try {
        const response = await structure.getClassroomList({ active: 1 });
        this.classrooms = response.data.items.map(x => ({
          ...x,
          label: `${x.stofa_eink} - ${x.stofa_heiti}`,
        }));
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading.classrooms = false;
      }
    },
    async loadCurrentTeachers() {
      this.validated = false;
      if (this.form.group) {
        try {
          const response = await school.getGroupTeachers(this.form.group.hopur_id);
          const teachers = response.data.hopar_kennarar || [];
          this.form.teachers = [];
          teachers.forEach(x => {
            if (this.teachers.find(y => y.starfsm_id === x.starfsm_id)) {
              this.form.teachers.push(this.teachers.find(y => y.starfsm_id === x.starfsm_id));
            }
          });
        } catch (e) {
          this.$log.error(e);
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        }
      }
    },
    async loadData() {
      this.validated = false;
      this.classLength = this.item.term.lengd_kennslustundar ? this.item.term.lengd_kennslustundar : 60;
      this.daysInWeek = this.item.term.fjoldi_tofludaga ? this.item.term.fjoldi_tofludaga : 5;
      this.loadModules();
      this.loadTeachers();
      this.loadClassrooms();
      this.loadEquipments();
    },
    flattenDates() {
      this.form.dates = [];
      const dates = [];
      this.form.periods.forEach(p => {
        const startDate = moment(p.dateFrom).toDate();
        const endDate = moment(p.dateTo).toDate();
        const currentDate = startDate;
        while (currentDate <= endDate) {
          const weekday = this.form.weekdays.find(x => (x.id === 7 && currentDate.getDay() === 0) || x.id === currentDate.getDay());
          if (weekday.times) {
            weekday.times.forEach(d => {
              dates.push({
                date: new Date(currentDate),
                time_from: d.time_from,
                time_to: d.time_to,
              });
            });
          }
          currentDate.setDate(currentDate.getDate() + 1);
        }
      });
      this.form.dates = dates;
    },
    updateSelectAll() {
      this.getDates.forEach(d => {
        this.$set(d, 'copy', this.selectAll);
      });
    },
    async validate() {
      try {
        this.validating = true;
        if (this.form.dates.length === 0) {
          this.flattenDates();
        }
        for (let i = 0; i < this.form.dates.length; i += 1) {
          const item = {
            stofur: this.form.classrooms.map(x => x.stofa_id).join(','),
            teachers: this.form.teachers.map(x => x.starfsm_id).join(','),
            hopur: this.form.group.hopur_id,
            dags: moment(this.form.dates[i].date).format('DD.MM.YYYY'),
            fra: this.form.dates[i].time_from,
            til: this.form.dates[i].time_to,
          };
          const response = await school.validateTimetable(item); // eslint-disable-line

          let equipmentBooked = 0;
          if (this.form.orderEquipment) {
            const equipmentResponse = await requests.getEquipmentIsBooked({// eslint-disable-line
              equipment_id: this.form.equipment.bunadur_id,
              date: moment(this.form.dates[i].date).format('DD.MM.YYYY'),
              time_from: this.form.dates[i].time_from,
              time_to: this.form.dates[i].time_to,
            });
            equipmentBooked = equipmentResponse.data.booked;
          }

          this.$set(this.form.dates[i], 'validation', response.data);
          this.$set(this.form.dates[i], 'equipment', equipmentBooked);
          this.$set(this.form.dates[i], 'copy', response.data.can_book);
        }
        this.validated = true;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.validating = false;
      }
    },
    async validateBeforeSubmit() {
      try {
        this.submitted = true;
        this.errorList = [];
        await this.$validator.validateAll().then(response => {
          if (!response) throw 'FormValidationError'; // eslint-disable-line no-throw-literal
        });

        if (!this.validated) {
          this.validate();
        } else {
          try {
            this.saving = true;
            const item = {
              onn: this.item.term.onn_id,
              afangi: this.form.module.afangi_id,
              hopur: this.form.group.hopur_id,
              stofur: this.form.classrooms.map(x => x.stofa_id).join(','),
              kennarar: this.form.teachers.map(x => x.starfsm_id).join(','),
              bunadur: this.form.orderEquipment ? this.form.equipment.bunadur_id : '',
              dags: this.getDates
                .filter(x => x.copy)
                .map(x => ({
                  dags: moment(x.date).format('DD.MM.YYYY'),
                  timi_fra: x.time_from,
                  timi_til: x.time_to,
                })),
            };
            await common.createTimetable(item);
            this.displaySuccess('Færslur stofnaðar');
            this.$emit('closeSlidebarAndReload');
          } catch (e) {
            // Aðgerð mistókst.
            this.failed = true;
            this.$log.debug(e);
            this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
          } finally {
            this.saving = false;
          }
        }
      } catch (e) {
        // Villur í formi.
        this.$log.debug(e);
      } finally {
        this.saving = false;
      }
    },
    copyTermDates() {
      if (this.form.periods.length === 0) {
        this.form.period.push({ dateFrom: '', dateTo: '' });
      }
      this.$set(this.form.periods[0], 'dateFrom', moment(this.item.term.dags_fra).toDate());
      this.$set(this.form.periods[0], 'dateTo', moment(this.item.term.dags_til).toDate());
    },
    addMultiDate(day) {
      if (day.times.length > 0 && day.times[day.times.length - 1].time_to) {
        const item = day.times[day.times.length - 1];
        const timeTo = moment().set('hour', item.time_to.split(':')[0]).set('minute', item.time_to.split(':')[1]).set('second', 0);
        day.times.push({
          time_from: item.time_to,
          time_to: moment(timeTo).add('minute', this.classLength).format('HH:mm'),
        });
      } else {
        day.times.push({ time_from: '', time_to: '' });
      }
    },
    removeMultiDate(day, index) {
      day.times.splice(index, 1);
    },
    addMultiPeriod() {
      this.form.periods.push({ dateFrom: '', dateTo: '' });
    },
    removeMultiPeriod(index) {
      this.form.periods.splice(index, 1);
      if (this.form.periods.length === 0) {
        this.form.periods.push({ dateFrom: '', dateTo: '' });
      }
    },
    updateTimeTo(day, index) {
      if (day && this.regexTime.test(day.times[index].time_from)) {
        const timeTo = moment()
          .set('hour', day.times[index].time_from.split(':')[0])
          .set('minute', day.times[index].time_from.split(':')[1])
          .set('second', 0);
        this.$set(day.times[index], 'time_to', moment(timeTo).add('minute', this.classLength).format('HH:mm'));
        this.$refs[`timeTo${day.id}${index}`][0].$refs.input.focus();
      } else if (!day && this.regexTime.test(this.form.dates[index].time_from)) {
        this.validated = false;
        const timeTo = moment()
          .set('hour', this.form.dates[index].time_from.split(':')[0])
          .set('minute', this.form.dates[index].time_from.split(':')[1])
          .set('second', 0);
        this.$set(this.form.dates[index], 'time_to', moment(timeTo).add('minute', this.classLength).format('HH:mm'));
        this.$refs[`timeTo${index}`][0].$refs.input.focus();
      }
    },
    copyFromOtherDay(day, copyFrom) {
      if (copyFrom) {
        const item = this.form.weekdays.find(x => x.id === copyFrom);
        if (item.times.length > 0) {
          this.$set(day, 'times', JSON.parse(JSON.stringify(item.times)));
        }
      }
    },
    clearValidation() {
      this.validated = false;
      this.form.dates = [];
    },
    getDays(day) {
      return this.form.weekdays
        .slice(0, this.daysInWeek)
        .filter(x => x.id !== day.id)
        .map(x => ({ id: x.id, name: x.name }));
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  watch: {
    item() {
      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss"></style>
